import React, { useState } from "react";
import { Modal, Box, Typography, IconButton, Dialog } from "@mui/material";
import "react-calendar/dist/Calendar.css";
import Calendar from "../../../shared/Layout/Calendar";
import useFetchWithAuth from "../../../features/hooks/useFetchWithAuth";

const PaymentsModal = ({ open, onClose }) => {
  const [currentDate, setCurrentDate] = useState(new Date(2025, 7, 24));
  const [selectedDate, setSelectedDate] = useState(24);

  const formatDate = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const dateStr = formatDate(currentDate);

  const { data, loading, error } = useFetchWithAuth(
    `/statistic/operator/metrics/${dateStr}/`,
    {},
    [currentDate]
  );

  const yourStats = data
    ? {
        upsellPercent: data.personal_details.percent_upsell,
        averageCheck: data.personal_details.average_check,
        leadsPerHour: data.personal_details.leads_per_hour,
      }
    : { upsellPercent: 0, averageCheck: "0.00", leadsPerHour: 0 };

  const workedStats = data
    ? data.work_log
    : { hours: "00:00:00", schedule: "-", facts: 0 };

  const finesAndBonuses = data
    ? data.financial_summary
    : { fine: "0.00", earned: "0.00", bonus: "0.00" };
  console.log("Дата для запроса:", dateStr);
  console.log("Полученные данные:", data, "Loading:", loading, "Error:", error);
  console.log("Ваші показники:", yourStats);
  console.log("Відпрацьоване:", workedStats);
  console.log("Штрафи та бонуси:", finesAndBonuses);

  return (
    <Modal fullScreen open={open} onClose={onClose}>
      <Box
        onClose={onClose}
        sx={{
          width: "100vw",
          height: "100vh",
          minWidth: "100vw",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "rgba(0,0,0,0.4)",
        }}
      >
        <Box
          onClick={(e) => e.stopPropagation()}
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 2,
            width: 1920,
            height: 700,
            maxWidth: "95vw",
            maxHeight: "95vh",
            justifyContent: "center",
            position: "relative",
            background: "transparent",
          }}
        >
          <Box
            sx={{
              background: "#fff",
              minWidth: 540,
              maxWidth: 540,
              width: 540,
              minHeight: 590,
              height: 590,
              p: 4,
              display: "flex",
              flexDirection: "column",
              borderRadius: "10px",
              ".dark-theme &": { background: "#101522" },
            }}
          >
            <Typography
              sx={{
                color: "#232B3E",
                fontWeight: 700,
                fontSize: 22,
                mb: 2,
                ".dark-theme &": { color: "#fff" },
              }}
            >
              Виберіть день
            </Typography>
            <Box sx={{ flex: 1, minHeight: 0 }}>
              <Calendar
                currentDate={currentDate}
                setCurrentDate={setCurrentDate}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                x
              />
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              flex: 1,
              minWidth: 800,
              height: "100%",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
              <Box
                sx={{
                  background: "#fff",
                  borderRadius: "16px",
                  flex: 1,
                  minHeight: 214,
                  height: 214,
                  p: 3,
                  display: "flex",
                  flexDirection: "column",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.01)",
                  ".dark-theme &": { background: "#101522" },
                }}
              >
                <Typography
                  sx={{
                    color: "#232B3E",
                    fontWeight: 700,
                    fontSize: 20,
                    mb: 3,
                    ".dark-theme &": { color: "#fff" },
                  }}
                >
                  Ваші показники
                </Typography>
                <Box
                  sx={{
                    borderTop: "1px solid #ECEEF2",
                    mt: 1,
                    ".dark-theme &": { borderTop: "1px solid #232B3E" },
                  }}
                />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    py: 1,
                    borderBottom: "1px solid #ECEEF2",
                    ".dark-theme &": { borderBottom: "1px solid #232B3E" },
                  }}
                >
                  <Typography
                    sx={{
                      color: "#232B3E",
                      fontWeight: 400,
                      fontSize: 17,
                      ".dark-theme &": { color: "#fff" },
                    }}
                  >
                    % допродажу
                  </Typography>
                  <Typography
                    style={{ color: "#22C55E", fontWeight: 600, fontSize: 17 }}
                  >
                    {yourStats.upsellPercent}%
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    py: 1,
                    borderBottom: "1px solid #ECEEF2",
                    ".dark-theme &": { borderBottom: "1px solid #232B3E" },
                  }}
                >
                  <Typography
                    sx={{
                      color: "#232B3E",
                      fontWeight: 400,
                      fontSize: 17,
                      ".dark-theme &": { color: "#fff" },
                    }}
                  >
                    Середній чек
                  </Typography>
                  <Typography
                    style={{ color: "#F87171", fontWeight: 600, fontSize: 17 }}
                  >
                    {yourStats.averageCheck}₴
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    py: 1,
                  }}
                >
                  <Typography
                    sx={{
                      color: "#232B3E",
                      fontWeight: 400,
                      fontSize: 17,
                      ".dark-theme &": { color: "#fff" },
                    }}
                  >
                    Лідів/год
                  </Typography>
                  <Typography
                    style={{ color: "#FACC15", fontWeight: 600, fontSize: 17 }}
                  >
                    {yourStats.leadsPerHour}
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  background: "#fff",
                  borderRadius: "16px",
                  flex: 1,
                  minHeight: 214,
                  height: 214,
                  p: 3,
                  display: "flex",
                  flexDirection: "column",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.01)",
                  ".dark-theme &": { background: "#101522" },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 2,
                  }}
                >
                  <Typography
                    sx={{
                      color: "#232B3E",
                      fontWeight: 700,
                      fontSize: 26,
                      ".dark-theme &": { color: "#fff" },
                    }}
                  >
                    Показники відпрацьованого
                  </Typography>
                  <IconButton
                    onClick={onClose}
                    sx={{
                      color: "#232B3E",
                      fontSize: 36,
                      p: 0,
                      ml: 2,
                      "&:hover": { color: "#232B3E" },
                      ".dark-theme &": {
                        color: "#fff",
                        "&:hover": { color: "#fff" },
                      },
                    }}
                  >
                    &times;
                  </IconButton>
                </Box>
                <Box
                  sx={{
                    borderTop: "1px solid #ECEEF2",
                    mt: 1,
                    ".dark-theme &": { borderTop: "1px solid #232B3E" },
                  }}
                />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    py: 1,
                    borderBottom: "1px solid #ECEEF2",
                    ".dark-theme &": { borderBottom: "1px solid #232B3E" },
                  }}
                >
                  <Typography
                    sx={{
                      color: "#232B3E",
                      fontWeight: 400,
                      fontSize: 17,
                      ".dark-theme &": { color: "#fff" },
                    }}
                  >
                    Години
                  </Typography>
                  <Typography
                    sx={{
                      color: "#232B3E",
                      fontWeight: 600,
                      fontSize: 17,
                      ".dark-theme &": { color: "#fff" },
                    }}
                  >
                    {workedStats.hours}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    py: 1,
                    borderBottom: "1px solid #ECEEF2",
                    ".dark-theme &": { borderBottom: "1px solid #232B3E" },
                  }}
                >
                  <Typography
                    sx={{
                      color: "#232B3E",
                      fontWeight: 400,
                      fontSize: 17,
                      ".dark-theme &": { color: "#fff" },
                    }}
                  >
                    Графік
                  </Typography>
                  <Typography
                    sx={{
                      color: "#232B3E",
                      fontWeight: 600,
                      fontSize: 17,
                      ".dark-theme &": { color: "#fff" },
                    }}
                  >
                    {workedStats.schedule}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    py: 1,
                  }}
                >
                  <Typography
                    sx={{
                      color: "#232B3E",
                      fontWeight: 400,
                      fontSize: 17,
                      ".dark-theme &": { color: "#fff" },
                    }}
                  >
                    Факти
                  </Typography>
                  <Typography
                    sx={{
                      color: "#232B3E",
                      fontWeight: 600,
                      fontSize: 17,
                      ".dark-theme &": { color: "#fff" },
                    }}
                  >
                    {workedStats.facts}
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                background: "#fff",
                borderRadius: "16px",
                minHeight: 175,
                height: 350,
                width: "100%",
                p: 3,
                display: "flex",
                flexDirection: "column",
                boxShadow: "0 2px 8px rgba(0,0,0,0.01)",
                ".dark-theme &": { background: "#101522" },
              }}
            >
              <Typography
                sx={{
                  color: "#232B3E",
                  fontWeight: 700,
                  fontSize: 20,
                  mb: 5,
                  ".dark-theme &": { color: "#fff" },
                }}
              >
                Штрафи та бонуси
              </Typography>
              <Box
                sx={{
                  borderTop: "1px solid #ECEEF2",
                  mt: 1,
                  ".dark-theme &": { borderTop: "1px solid #232B3E" },
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  py: 1,
                  borderBottom: "1px solid #ECEEF2",
                  ".dark-theme &": { borderBottom: "1px solid #232B3E" },
                }}
              >
                <Typography
                  sx={{
                    color: "#232B3E",
                    fontWeight: 400,
                    fontSize: 17,
                    ".dark-theme &": { color: "#fff" },
                  }}
                >
                  Штраф
                </Typography>
                <Typography
                  sx={{
                    color: "#232B3E",
                    fontWeight: 600,
                    fontSize: 17,
                    ".dark-theme &": { color: "#fff" },
                  }}
                >
                  {finesAndBonuses.fine}₴
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  py: 1,
                  borderBottom: "1px solid #ECEEF2",
                  ".dark-theme &": { borderBottom: "1px solid #232B3E" },
                }}
              >
                <Typography
                  sx={{
                    color: "#232B3E",
                    fontWeight: 400,
                    fontSize: 17,
                    ".dark-theme &": { color: "#fff" },
                  }}
                >
                  Зароблено
                </Typography>
                <Typography
                  sx={{
                    color: "#232B3E",
                    fontWeight: 600,
                    fontSize: 17,
                    ".dark-theme &": { color: "#fff" },
                  }}
                >
                  {finesAndBonuses.earned}₴
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  py: 1,
                }}
              >
                <Typography
                  sx={{
                    color: "#232B3E",
                    fontWeight: 400,
                    fontSize: 17,
                    ".dark-theme &": { color: "#fff" },
                  }}
                >
                  Бонус
                </Typography>
                <Typography
                  sx={{
                    color: "#232B3E",
                    fontWeight: 600,
                    fontSize: 17,
                    ".dark-theme &": { color: "#fff" },
                  }}
                >
                  {finesAndBonuses.bonus}₴
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default PaymentsModal;
